var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloseJoinLPublicLiveStream(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCloseJoinLPublicLiveStream") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.2720492,10.8000488 L20.6880137,3.38407565 C21.3706621,2.70142641 21.3706621,1.59463617 20.6880137,0.912084589 C20.0053652,0.229435351 18.898674,0.229435351 18.2160255,0.912084589 L10.7999634,8.32815543 L3.38390124,0.911986928 C2.7012528,0.229337691 1.59456152,0.229337691 0.911913082,0.911986928 C0.229362306,1.59463617 0.229362306,2.70142641 0.911913082,3.38397799 L8.32797522,10.7999512 L0.911913082,18.216022 C0.229362306,18.8986712 0.229362306,20.0054615 0.911913082,20.6880131 C1.59456152,21.3706623 2.7012528,21.3706623 3.38390124,20.6880131 L10.7999634,13.2719422 L18.2160255,20.6880131 C18.8985763,21.3706623 20.0053652,21.3706623 20.6880137,20.6880131 C21.3706621,20.0053638 21.3706621,18.8986712 20.6880137,18.216022 L13.2720492,10.8000488 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chatrooms_LiveStream-Connecting",
    transform: "translate(-324.000000, -30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icCloseJoinLPublicLiveStream",
    transform: "translate(324.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/white",
    mask: "url(#mask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30.000000, -30.000000)",
    id: "colour/light-grey"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 82 0 82 82 0 82"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseJoinLPublicLiveStream);
export default __webpack_public_path__ + "static/media/icCloseJoinLPublicLiveStream.394d47d5a3fe10a615d6136a9408d70c.svg";
export { ForwardRef as ReactComponent };